module.exports = __webpack_public_path__ + "static/media/oracle.f02dafc9.png";